import { Activity } from 'react';
import { Center, Loader } from '@mantine/core';
import { MChatConversation } from '@/src/modules/chat/models/chat-conversation';
import { ChatConversationTile } from './chat-conversation-tile';

interface IChatConversationListProps {
  size?: 'sm' | 'md';
  conversations: MChatConversation[];
  isLoadingMore?: boolean;
  selectedConversationId?: number | null;
  setSelectedConversationId?: (conversationId: number) => void;
  showLastMessages?: boolean;
}

export function ChatConversationTileList({
  size = 'md',
  conversations,
  isLoadingMore = false,
  selectedConversationId,
  setSelectedConversationId,
  showLastMessages = true,
}: IChatConversationListProps) {
  const onTileClick = (conversation: MChatConversation) => {
    setSelectedConversationId?.(conversation.props.id);
    conversation.clearUnreadMessages();
  };

  return (
    <>
      {conversations.map((conversation) => (
        <ChatConversationTile
          key={conversation.props.id}
          size={size}
          conversation={conversation}
          isSelected={conversation.props.id === selectedConversationId}
          onClick={() => onTileClick(conversation)}
          showLastMessage={showLastMessages}
        />
      ))}

      <Activity mode={isLoadingMore ? 'visible' : 'hidden'}>
        <Center>
          <Loader size="sm" />
        </Center>
      </Activity>
    </>
  );
}
